import React, { useEffect, useState } from 'react';
import {
    Box,
    Collapse,
    TableRow,
    TableCell,
    IconButton,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import BannerAdEchoBuilder from './bannerAdEchoBuilder';
import { ECHO_TYPE } from '../../../../../constants';

function BannerAdEchoRow(props) {
    const { id, name, imageUrl, duration, type } = props;
    const [open, setOpen] = useState(false);
    return (
        <>
            <TableRow className="echo-row" key={'banner-echo-row-'+id}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>{id}</TableCell>
                <TableCell>{name}</TableCell>
                <TableCell>{duration}</TableCell>
                <TableCell>{ECHO_TYPE[type]}</TableCell>
            </TableRow>
            <TableRow key={'banner-echo-row-details-'+id}>
                <TableCell className="py-0" colSpan={5}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <BannerAdEchoBuilder
                                key={'banner-echo-builder-'+id}
                                id={id}
                                name={name}
                                imageUrl={imageUrl}
                                duration={duration}
                                type={type}
                                handleEchoRowState={() => setOpen(!open)}
                            />
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

export default BannerAdEchoRow;
